export default {
  LIST_FETCHED: 'PARTNERS_FETCHED',
  LIST_LOAD: 'PARTNERS_LOAD',
  ITEM_DETAIL: 'PARTNERS_DETAIL',
  BUTTON_LOAD: 'PARTNERS_BUTTON_LOAD',
};
